module.exports = __webpack_public_path__ + "img/qrcode_r.1ed78a92.png";